<template>
  <div class="wrapper">
    <div class="wrapper-bg" />
    <div class="logo" />
    <div class="center d-flex justify-space-between align-start">
      <div
        class="d-flex"
        style="border-radius: 6px; overflow: hidden"
      >
        <img
          width="540"
          height="480"
          src="http://hh-oss-picture.miyapay.com/box/013564b7279619e9cbb644963abc82ef.png"
        >
        <div class="form">
          <div class="title">
            登录
          </div>
          <a-form
            :form="form"
            :wrapper-col="{ span: 24 }"
          >
            <a-form-item>
              <a-input
                style="height: 48px; line-height: 48px"
                size="large"
                autocomplete="off"
                placeholder="请输入您的用户名"
                v-decorator="['userName',
                              { rules: [{ required: true, message: '请输入您的用户名!' }] }]"
              >
                <a-icon
                  style="font-size: 18px"
                  slot="prefix"
                  type="user"
                />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                style="height: 48px; line-height: 48px"
                type="password"
                placeholder="请输入密码"
                size="large"
                v-decorator="['password',
                              { rules: [{ required: true, message: '请输入密码!' }] }]"
                @pressEnter="pressEnter"
              >
                <a-icon
                  style="font-size: 18px"
                  slot="prefix"
                  type="lock"
                />
              </a-input>
            </a-form-item>
          </a-form>
          <div
            v-if="showLoginError"
            style="margin-top: -10px; margin-bottom: 10px"
            class="d-flex align-center"
          >
            <img
              width="14"
              height="14"
              src="http://hh-oss-picture.miyapay.com/box/4fbd8c03e0fd2247d8537d57974491d1.png"
            >
            <span style="margin-left: 7px; color: #F00808">账号或密码错误</span>
          </div>
          <div style="marginTop: -20px; text-align: right">
            <a-button
              type="link"
              style="padding-right: 0; color: #16BFD5;"
              @click="forgetModalVisible = true"
            >
              忘记密码?
            </a-button>
          </div>
          <a-button
            type="primary"
            class="login-btn"
            :loading="isLoggingIn"
            @click="login"
          >
            登录
          </a-button>
          <a-button
            type="link"
            style="padding-left: 0; color: #16BFD5; margin-top: 12px"
            @click="tryModalVisible = true"
          >
            想要获取试用账号?
          </a-button>
        </div>
        <a-modal
          title="忘记密码"
          :visible="forgetModalVisible"
          @ok="forgetModalVisible = false"
          @cancel="forgetModalVisible = false"
        >
          <p>请联系您的客户经理或系统管理员。 我们将为您找回密码。</p>
        </a-modal>
        <a-modal
          title="如何获取测试账号？"
          :visible="tryModalVisible"
          @ok="tryModalVisible = false"
          @cancel="tryModalVisible = false"
        >
          <p>巨犀专业的销售、运营、数据团队将为你提供全方位的服务，并在你使用产品的过程中提供帮助与支持。</p>
          <p>获取试用账号请联系：186 0868 1866</p>
        </a-modal>
      </div>
    </div>
  </div>
</template>
<script>
import { noop } from 'lodash';
import { goToFirstValidRoute } from '@/utils/helpers';

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      showLoginError: false,
      redirect_uri: null,
      client_id: null,
      state: null,
      isLoggingIn: false,
      forgetModalVisible: false,
      tryModalVisible: false,
    };
  },
  mounted() {
    document.title = '巨犀';
  },
  methods: {
    async login() {
      try {
        const values = await this.form.validateFields();
        this.isLoggingIn = true;
        this.$store.dispatch('user/loginReq', values)
          .then(() => { goToFirstValidRoute(this.$router); document.title = '云察商户平台'; })
          .catch(noop);
      } catch (err) {
        window.console.error(err);
      } finally {
        this.isLoggingIn = false;
      }
    },
    pressEnter() {
      this.login();
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  position: relative;
  height: 100vh;
  min-height: 700px;

  &-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(http://hh-oss-picture.miyapay.com/box/b905b541efc02d35578d5b64753b24b5.png);
    background-size: 100% 100%;
  }

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #1F2D7B;
  }
}

.center {
  width: 960px;
  height: 480px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.form {
  width: 420px;
  height: 480px;
  background:rgba(255,255,255,1);
  box-shadow:0px 8px 16px 0px rgba(0,0,0,0.12);
  padding: 74px 48px 48px 48px;

  .title {
    color: #333333;
    font-size: 32px;
    font-weight: 500;
    line-height: 45px;
    margin-bottom: 35px;
  }

  .login-btn {
    width: 100%;
    margin-top: 15px;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    background: #16BFD5;
    border: 0;

    &:hover, &:focus {
      background: #16BFD5;
    }
  }
}

.copyright {
  position: absolute;
  width: 100%;
  height: 14px;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  color: #fff;
  text-align: center;
}
</style>
<style lang="scss">
.form .antmain-input-lg {
  height: 48px !important;
  padding-left: 46px !important;
  border: 1px solid #D9D9D9!important;
  color: #333;

  &::placeholder {
    color: #999;
  }
}

.form .anticon {
  color: #333;
}

.form .antmain-form-item {
  margin-bottom: 20px;
}

.form .antmain-form-item-control .antmain-form-explain {
  color: red;
}
</style>
